import { action, observable, makeObservable } from 'mobx';
import { ReturnAddressForm } from 'modules/return-address/forms';
import { ApplicationStore } from 'platform/application/stores';
import { BaseViewStore } from 'core/stores';
import { FormHelperService } from 'common/data';
import { notificationError, isSome, isSuperAdminOrganization } from 'core/utils';
import { LookupStore } from 'modules/lookup/stores';
import { ReturnAddressStore } from 'modules/return-address/stores';
import { BaasicDropdownViewStore } from 'common/stores';
import { localStorageHandler } from 'core/services';
import { lookupRouteName, sourceOfChange } from 'common/constants';
import _ from 'lodash';

class ReturnAddressEditViewStore extends BaseViewStore {
	isUpdateAction = isSome(this.rootStore.routerStore.routerState.params.id);
	organizationTypeId = null;
	@observable stateOptions = [];
	@observable tempStateOptions = [];
	@observable pageState = 1;
	@observable countryOptions = [];
	@observable tempCountryOptions = [];
	@observable pageCountry = 1;
	@observable infiniteSearchPhrase = null;
	debouncedStateSearch = null;
	debouncedCountrySearch = null;
	returnAddress;
	isEdit = false;
	isSuperAdmin = false;
	@observable isStateLoading = false;
	@observable isCountryLoading = false;

	form = new ReturnAddressForm({
		onSuccess: async () => {
			this.createOrUpdateReturnAddress();
		},
	});

	constructor(rootStore, { parentViewStore }) {
		super(rootStore);
		makeObservable(this);
		this.parentView = parentViewStore;
		this.listStore = new ReturnAddressStore(rootStore);
		this.lookupStore = new LookupStore(rootStore);
		this.formHelperService = new FormHelperService();
		this.isEdit = this.parentView.isEdit;
		this.isSuperAdmin = isSuperAdminOrganization(rootStore);
		this.initialize();
	}

	@action async initialize() {
		this.suspend();
		this.form.state.options.set({
			validateOnBlur: false,
			showErrorsOnReset: false,
			validateOnChange: true,
		});
		this.form.reset();
		this.stateDropdownStore = new BaasicDropdownViewStore({
			lookupRoute: lookupRouteName.state,
			field: this.form.$('state'),
			store: this.lookupStore,
			itemTemplate: {
				value: 'id',
				label: 'name',
			},
		});
		this.countryDropdownStore = new BaasicDropdownViewStore({
			lookupRoute: lookupRouteName.country,
			field: this.form.$('country'),
			store: this.lookupStore,
			itemTemplate: {
				value: 'id',
				label: 'name',
			},
		});
		if (this.isSuperAdmin) {
			this.sellerDropdownStore = new BaasicDropdownViewStore({
				field: this.form.$('seller'),
				store: new ApplicationStore(this.rootStore),
				itemTemplate: {
					value: 'id',
					label: 'applicationTitle',
				},
				filterProperties: {
					sellerOnly: true,
				},
			});
			this.form.$('seller').set('rules', 'required');
			const seller = localStorageHandler.get('selectedSeller');
			if (seller) {
				this.sellerDropdownStore.setValue(seller);
				this.form.$('seller').value = seller;
				await this.sellerDropdownStore.reload();
			}
		}
		if (this.isEdit) {
			this.returnAddress = this.parentView.selectedItem;
			this.formHelperService.updateForm(this.form, this.returnAddress, true);
			this.form.$('country').value = {
				value: this.returnAddress.address.coreCountryId,
				label: this.returnAddress.address.coreCountry.name,
			};
			this.form.$('state').value = {
				value: this.returnAddress.address.coreCountryStateId,
				label: this.returnAddress.address.coreCountryState.name,
			};
		}

		this.resume();
	}

	@action.bound
	onCheck = async event => {
		this.form.$('isDefaultReturnAddress').value = event.currentTarget.checked;
	};

	@action.bound async createOrUpdateReturnAddress() {
		this.suspend();
		const { name, address, country, state, isDefaultReturnAddress, seller } = this.form.values();
		try {
			if (this.isEdit) {
				let addressObjforUpdate = {
					id: this.returnAddress.addressId,
					...address,
					coreCountryStateId: state.value,
					coreCountryId: country.value,
				};

				var ReturnAddressForUpdate = {
					id: this.returnAddress.id,
					name: name,
					addressId: this.returnAddress.addressId,
					Address: addressObjforUpdate,
					sellerId: this.returnAddress.seller.id,
					seller: this.returnAddress.seller,
					isDefaultReturnAddress: isDefaultReturnAddress,
					isWarehouse: false,
					fullAddress: '',
				};
				await this.listStore.updateReturnAddress(ReturnAddressForUpdate, sourceOfChange.updateReturnAddress);
				this.rootStore.notificationStore.success(['RETURNADDRESSVIEW.EDITSUCCESS', { name: name }]);
			} else {
				let addressObjforCreate = {
					...address,
					coreCountryStateId: state.value,
					coreCountryId: country.value,
				};
				var ReturnAddressForCreate = {
					name: name,
					Address: addressObjforCreate,
					sellerId: this.isSuperAdmin ? seller.value : this.parentView.seller.id,
					seller: this.isSuperAdmin ? seller.extra : this.parentView.seller,
					isDefaultReturnAddress: isDefaultReturnAddress,
					isWarehouse: false,
					fullAddress: '',
				};
				await this.listStore.createReturnAddress(ReturnAddressForCreate, sourceOfChange.createReturnAddress);
				this.rootStore.notificationStore.success(['RETURNADDRESSVIEW.CREATESUCCESS', { name: name }]);
			}
			this.parentView.editModal.close();
		} catch (err) {
			notificationError({ store: this.rootStore.notificationStore, err });
		}
		this.resume();
	}
}

export default ReturnAddressEditViewStore;



// WEBPACK FOOTER //
// ./src/modules/return-address/stores/ReturnAddressEditViewStore.js